import React from 'react'
import { TextField } from 'react-admin'
import { DateField, ListGuesser } from 'theme/components'

export const MontaStockList = (props) => (
  <ListGuesser
    {...props}
    hasEdit={false}
    rowClick="edit"
    bulkActionButtons={false}
  >
    <TextField
      source={'originId'}
      label={'id'}
      sortBy={'id'}
      sort={{ field: 'id', order: 'DESC' }}
    />
    <TextField source="sku" label={'SKU'} />
    <TextField source="barcodePrimary" label="Primary Barcode" />
    <TextField source="description" label="Description" />
    <DateField source="createdAt" />
  </ListGuesser>
)
